export default __webpack_public_path__ + "static/media/callMeLogs.b504bcc3.svg";